import * as React from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useAuthProvider } from "../../core/authContext";
import {
  useGetDineInSectionsQuery,
  DineInSection,
  useDeleteDineInSectionsMutation, useAddDineInSectionsMutation
} from "../../generated/graphql";
const useSection = () => {
  const [editData, setEditData] = React.useState<DineInSection | null>(null);
  const [open, setOpen] = React.useState(false);
  const [isCustomized, setIsCustomized] = React.useState<boolean>(false);
  const handleClickEditOpen = (data: DineInSection | null) => {
    setEditData(data);
    setOpen(true);
    setIsCustomized(data?.uploaded_icon ? true : false)
  };
  const handleEditClose = () => {
    setEditData(null);
    setOpen(false);
  };

  const { getUser } = useAuthProvider();
  const property = getUser();

  // add categories
  const {
    data: Sections,
    refetch: refetchSection,
    loading: loadingCategories,
  } = useGetDineInSectionsQuery({
    fetchPolicy: "network-only",
    variables: {
      propertyID: property?.id,
    },
  });
  const [deleteSections] = useDeleteDineInSectionsMutation();

  // delete categories
  const handleDelete = async (id: string) => {
    try {
      await deleteSections({
        variables: {
          id: id,
          propertyID: property?.id,
        },
      });
      swal({
        text: "Section Deleted Successfully",
        icon: "success",
      });
      refetchSection();
    } catch (err) {
      swal({
        text: `${err}`,
        icon: "error",
      });
    }
  };


  const [upsertSections] = useAddDineInSectionsMutation();

  const onSave = async (data: DineInSection) => {
    try {
      const res = await upsertSections({
        variables: {
          dineInSectionInput: {
            id: data?.id || "",
            name: data.name,
            icon: data.icon,
            property_id: property?.id,
            desc: data?.desc,
            sequence: data?.sequence,
            start_time: data.start_time,
            end_time: data.end_time,
            is_Activated: data?.is_Activated
          },
        },
      });
      if (res.data?.upsertDineInSection) {
        setOpen(false);
        swal({
          text: "Section updated Successfully",
          icon: "success",
        });
      }
    } catch (err) {
      swal({
        text: `${err}`,
        icon: "error",
      });
    }
  };


  const onToggleSection = async (data: DineInSection) => {
    if (data.is_Activated === false) {
      Swal.fire({
        text: `All items linked to ${data.name} section will also be enabled`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Accept!",
      }).then((result) => {
        if (result.isConfirmed) {
          (async () => {
            try {
              const res = await upsertSections({
                variables: {
                  dineInSectionInput: {
                    id: data?.id || "",
                    name: data.name,
                    icon: data.icon,
                    property_id: property?.id,
                    desc: data?.desc,
                    sequence: data?.sequence,
                    start_time: data.start_time,
                    end_time: data.end_time,
                    is_Activated:true
                  },
                },
              });
              if (res.data?.upsertDineInSection) {
                setOpen(false);
                swal({
                  text: "section updated Successfully",
                  icon: "success",
                });
              }
              refetchSection();
            } catch (err) {
              swal({
                text: `${err}`,
                icon: "error",
              });
            }
          })();
        }
      });
    } else {
      try {
        const res = await upsertSections({
          variables: {
            dineInSectionInput: {
              id: data?.id || "",
              name: data.name,
              icon: data.icon,
              property_id: property?.id,
              desc: data?.desc,
              sequence: data?.sequence,
              start_time: data.start_time,
              end_time: data.end_time,
              is_Activated:false
            },
          },
        });
        if (res.data?.upsertDineInSection) {
          setOpen(false);
          swal({
            text: "section updated Successfully",
            icon: "success",
          });
        }
        refetchSection();
      } catch (err) {
        swal({
          text: `${err}`,
          icon: "error",
        });
      }
    }
  };


  return {
    Sections: Sections?.getAllDineInSections,
    handleClickEditOpen,
    handleEditClose,
    editData,
    refetchSection,
    propertyId: property?.id,
    open,
    setOpen,
    loadingCategories,
    handleDelete,
    onSave,
    onToggleSection,
    isCustomized,
    setIsCustomized
  };
};

export default useSection;
